import { Box, Button, Tab, Tabs } from "@mui/material";
import { useState } from "react";
import { LayoutBaseDePagina } from "../../../shared/layouts"; // Layout do projeto
import { AnalysisTab } from "./tabs/AnalysisTab";
import { RepassesTab } from "./tabs/RepassesTab";
import { useNavigate } from "react-router-dom";
import { checkByProfileGuard } from "../../../shared/guards/ProfileGuard";
import { PermissionActionsEnum, PermissionRolesEnum } from "../../../shared/enums/profiles";


export const ToolsPagePresentation = () => {
	const navigate = useNavigate();
	const [selectedTab, setSelectedTab] = useState(0); // Estado para gerenciar a tab selecionada
	const canAccessReadjustShortcut =
		checkByProfileGuard(PermissionRolesEnum.FinancialMenu, PermissionActionsEnum.View) &&
		checkByProfileGuard(PermissionRolesEnum.FinancialOptions, PermissionActionsEnum.ReadjustView);

	// Função para controlar a mudança de tab
	const handleTabChange = (event: React.SyntheticEvent, newValue: number) => {
		setSelectedTab(newValue);
	};

	return (
		<LayoutBaseDePagina titulo="Ferramentas" subtitulo="Gestao de Ferramentas" barraDeFerramentas={<></>}>
			<Box
				sx={{
					display: "flex",
					alignItems: "center",
					justifyContent: "space-between",
					mx: 1,
					gap: 2,
				}}
			>
				<Tabs
					value={selectedTab}
					onChange={handleTabChange}
					aria-label="Ferramentas"
					sx={{
						flex: 1,
						borderBottom: 1,
						borderColor: "divider",
						bgcolor: "background.paper",
						borderRadius: 1,
						bordercolor: "divider",
					}}
				>
					<Tab label="Analises" />
					<Tab label="Garantias" />
					<Tab label="Repasses" />
				</Tabs>

				{canAccessReadjustShortcut && (
					<Button
						variant="contained"
						color="primary"
						onClick={() => navigate("/reajuste")}
						sx={{ whiteSpace: "nowrap" }}
					>
						Reajustes
					</Button>
				)}
			</Box>

			<Box sx={{ pt: 1 }}>
				{/* Tab de Análise */}
				{selectedTab === 0 && <AnalysisTab />}

				{/* Tab de Garantias */}
				{/* {selectedTab === 1 && <BilletCardTab />} */}

				{/* Tab de Repasses */}
				{selectedTab === 2 && <RepassesTab />}
			</Box>
		</LayoutBaseDePagina>
	);
};
